import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RefreshIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M11.7667 4.23268C10.8 3.26602 9.47333 2.66602 8 2.66602c-2.94667 0-5.32667 2.38666-5.32667 5.33333 0 2.94665 2.38 5.33335 5.32667 5.33335 2.4867 0 4.56-1.7 5.1533-4.00002h-1.3866C11.22 10.886 9.74 11.9993 8 11.9993c-2.20667 0-4-1.7933-4-3.99995 0-2.20667 1.79333-4 4-4 1.10667 0 2.0933.46 2.8133 1.18667L8.66667 7.33268h4.66663V2.66602l-1.5666 1.56666Z" />
  </Icon>
);

export default memo(RefreshIcon);
